import type * as React from 'react'
import { Inbox } from 'lucide-react'

export interface EmptyStateProps {
  message?: React.ReactNode
}

export function EmptyState({ message = 'No data available' }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Inbox className="mb-4 h-12 w-12 text-textMuted" />
      <p className="text-sm text-textMuted">{message}</p>
    </div>
  )
}
